export const initialValuesFormBeneficiarios = {
    beneficiarios: [],
    checkBeneficiario: false
};